"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SelectButton_1 = __importDefault(require("./SelectButton"));
const SelectContext_1 = require("../../contexts/SelectContext");
const SelectDropdown_1 = __importDefault(require("./SelectDropdown"));
const __1 = require("../..");
const helpers_1 = require("../../lib/helpers");
const Select = (props) => {
    const { children, buttonProps, targetRef: targetRefFromProps, label, onOpen, onClose, isOpen, } = props;
    const targetRef = react_1.useRef(null);
    if (targetRefFromProps === null || targetRefFromProps === void 0 ? void 0 : targetRefFromProps.current) {
        targetRef.current = targetRefFromProps.current;
    }
    const [open, setOpen] = react_1.useState(false);
    const clickedAwayAt = react_1.useRef(0);
    const onCloseHandle = react_1.useCallback(() => {
        clickedAwayAt.current = Date.now();
        setOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    const handleOpen = react_1.useCallback((newOpen, element) => {
        targetRef.current = element;
        if (!newOpen) {
            onClose && onClose();
        }
        else {
            onOpen && onOpen();
        }
        setOpen(newOpen);
    }, [targetRef, onClose, onOpen]);
    react_1.useEffect(() => {
        if (isOpen !== undefined) {
            setOpen(isOpen);
        }
    }, [isOpen]);
    const hasSelectButton = helpers_1.hasChildComponent(props, 'j-select-button');
    const hasSelectDropdown = helpers_1.hasChildComponent(props, 'j-select-dropdown');
    const contextValue = react_1.useMemo(() => (Object.assign(Object.assign({}, props), { targetRef, isOpen: open, onClose: onCloseHandle, clickedAwayAt, setOpen: handleOpen })), [handleOpen, onCloseHandle, open, props, targetRef]);
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    return (react_1.default.createElement(SelectContext_1.SelectContext.Provider, { value: contextValue },
        react_1.default.createElement("div", Object.assign({}, primitiveProps),
            !hasSelectButton ? react_1.default.createElement(SelectButton_1.default, Object.assign({}, Object.assign({ label }, buttonProps))) : react_1.default.createElement(react_1.default.Fragment, null, children),
            !hasSelectDropdown && (react_1.default.createElement(SelectDropdown_1.default, null, children)),
            !hasSelectDropdown && !hasSelectButton && react_1.default.createElement(react_1.default.Fragment, null, children))));
};
exports.default = __1.withJourney('j-select', Select);
